import React, { useContext, useEffect, useCallback }from 'react';

import PresentPC from 'components/pages/Thanks/PresentPC';
import PresentSP from 'components/pages/Thanks/PresentSP';

import { 
  useWindowDimensions,
  useDirectTransCheck,
  useIECheck,
  MoveCheckStop,
  scrollTop,
} from 'utils';
import { LP_URL } from 'utils/constant';
import AppContext from 'fluxes/context';
import { CHANGE_MODIFY_MODE, REGISTER } from 'fluxes/actions';

const Thanks = ()=>{
  const { state, dispatch } = useContext(AppContext);

  // レスポンシブ
  const { width } = useWindowDimensions();
  const isIE = useIECheck();
  const isSp = width <= 640 && !isIE;

  // 直接遷移チェック
  useDirectTransCheck({ state });

  MoveCheckStop();

  // ブラウザバックを禁止する
  const blockBrowserBack = useCallback(() => {
    window.history.go(1)
  }, [])

  useEffect(() => {
    // 直前の履歴に現在のページを追加
    window.history.pushState(null, null, window.location.href)

    // 直前の履歴と現在のページのループ
    window.addEventListener('popstate', blockBrowserBack)

    // クリーンアップ
    return () => {
      window.removeEventListener('popstate', blockBrowserBack)
    }
  }, [blockBrowserBack])

  // クリア
  useEffect(() => {
    dispatch({
      type: CHANGE_MODIFY_MODE,
      isModify: false,
    });
    dispatch({ type: REGISTER });
  }, [ dispatch ]);

  const onClickMainButton = {
    next: () => {
      scrollTop();
      window.location.href = LP_URL;
    },
  };
  return isSp ? (
    <PresentSP
      onClickMainButton={onClickMainButton}
    />
  ) : (
    <PresentPC
      onClickMainButton={onClickMainButton}
    />
  );
};

export default Thanks;